export const GUIA_HISTORY_PERMISSION = "knowledge_assistants.history";
export const GUIA_HISTORY_PATH = "/app/guia-history";

interface GuiaHistoryNavInput {
  can: (key: string) => boolean;
  isAdmin: boolean;
  isCoordinator: boolean;
}

export function canSeeGuiaHistoryNav({ can, isAdmin, isCoordinator }: GuiaHistoryNavInput): boolean {
  return can(GUIA_HISTORY_PERMISSION) || isAdmin || isCoordinator;
}
